var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionDetailsDialog", {
        attrs: { viewModel: _vm.criterionDetailsDialog },
      }),
      _vm._v(" "),
      _c("WeightsViewerDialog", {
        attrs: {
          propOpened: _vm.weightsViewerOpened === true,
          propRm: _vm.weightsViewer,
        },
        on: {
          "export-panelist-weights":
            _vm.handleExportWeightsToXlsFromPanelistVotesCommand,
          "close-dialog": function ($event) {
            _vm.weightsViewerOpened = false
          },
        },
      }),
      _vm._v(" "),
      _c("PanelistConsistencyAnalysisDialog", {
        attrs: {
          propOpened: _vm.panelistConsistencyAnalysisOpened === true,
          propRm: _vm.panelistConsistencyAnalysis,
        },
        on: {
          "close-dialog": function ($event) {
            _vm.panelistConsistencyAnalysisOpened = false
          },
        },
      }),
      _vm._v(" "),
      _vm.viewTemplate === "default"
        ? [
            _c(
              "nav",
              { staticClass: "navbar navbar-expand-md navbar-dark bg-dark" },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "form",
                    { staticClass: "form-inline my-2 my-lg-0 ml-auto" },
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "sanitizedHref",
                              rawName: "v-sanitizedHref",
                              value: _vm.rm.MeetingUrl,
                              expression: "rm.MeetingUrl",
                            },
                          ],
                          staticClass: "btn btn-light mr-2",
                        },
                        [_vm._v("Join Meeting")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-group mr-2",
                          attrs: { role: "group" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-light dropdown-toggle",
                              attrs: {
                                type: "button",
                                "data-toggle": "dropdown",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            My votes\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "dropdown-menu" }, [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: _vm.showRespondentConsistencyAnalysis,
                                },
                              },
                              [_vm._v("Check consistency")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: { click: _vm.showWeightsViewer },
                              },
                              [_vm._v("View weights")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click:
                                    _vm.handleExportPanelistVotesToXlsCommand,
                                },
                              },
                              [_vm._v("Download to xls")]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container" }, [
              _c("h3", { staticClass: "mt-5 font-weight-light" }, [
                _vm._v("Survey: " + _vm._s(_vm.rm.SurveyName)),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Weight " +
                    _vm._s(_vm.rm.CriteriaCount) +
                    " criteria grouped into " +
                    _vm._s(_vm.rm.Contexts.length) +
                    " contexts by making " +
                    _vm._s(_vm.rm.SurveyQuestionsCount) +
                    " pairwise comparisons."
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "lead" }, [
                _vm._v(_vm._s(_vm.rm.SurveyDescription)),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("table", { staticClass: "table table-hover mt-3" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Context")]),
                    _vm._v(" "),
                    _c("th", [
                      _c(
                        "a",
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              _vm.orderByProgressAsc = !_vm.orderByProgressAsc
                            },
                          },
                        },
                        [_vm._v("Progress")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", { staticStyle: { width: "120px" } }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.criteriaView, function (c) {
                    return _c("tr", { key: c.Id }, [
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            on: {
                              click: function ($event) {
                                return _vm.showCriterionDetails(c)
                              },
                            },
                          },
                          [_vm._v(_vm._s(c.Name))]
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("small", [_vm._v(_vm._s(c.Path))]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c(
                          "div",
                          {
                            staticClass: "progress",
                            staticStyle: { height: "30px" },
                          },
                          [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: { width: c.Progress + "%" },
                              attrs: { role: "progressbar", title: c.Progress },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-center" }, [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: c.EvaluationUrl,
                                expression: "c.EvaluationUrl",
                              },
                            ],
                            staticClass: "btn btn-outline-primary",
                          },
                          [_vm._v("Weight")]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "loading" ? [_vm._m(1)] : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "closed"
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center",
                staticStyle: { "padding-top": "200px" },
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Survey is closed"),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text lead" }, [
                      _vm._v(
                        "Please wait for the host to open this survey or go to the meeting."
                      ),
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: _vm.rm.MeetingUrl,
                            expression: "rm.MeetingUrl",
                          },
                        ],
                        staticClass: "btn btn-secondary",
                      },
                      [_vm._v("Go to the meeting")]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.viewTemplate === "empty"
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center",
                staticStyle: { "padding-top": "200px" },
              },
              [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v("Empty survey: " + _vm._s(_vm.rm.SurveyName)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "card-text lead" }, [
                      _vm._v(
                        "Sorry. This survey has no questions. Please contact the person who asked you to complete the survey for advice."
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-light",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/respondents-weights",
          title: "Respondents guide: Criteria Weights",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("h3", { staticClass: "text-center" }, [
        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
        _vm._v(" Loading..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }